const airbrake = require('client/lib/airbrake')
const Promise = require('bluebird')

const EXTENSION_TIMEOUT = 100

const callExtension = (call, timeout) => {
  if (exists()) {
    return Promise.resolve(call(window.mixext))
    .timeout(timeout || EXTENSION_TIMEOUT)
    .catch(err => {
      airbrake.notify(err)
      throw err
    })
  }
  return Promise.reject(new Error('Mix extension does not exist'))
}

const exists = () => !!window.mixext

const ping = () => {
  return callExtension(ext => ext.ping())
  .catch(() => {
    // Handle the error and do nothing
    return null
  })
}

const clearUserCache = () => {
  return callExtension(ext => ext.clearUserCache())
  .catch(() => {
    // Handle the error and do nothing
    return null
  })
}

const clearUrlCache = (urlId) => {
  return callExtension(ext => ext.clearUrlCache(urlId))
  .catch(() => {
    // Handle the error and do nothing
    return null
  })
}

const clearUrlStateCache = (urlId) => {
  return callExtension(ext => ext.clearUrlStateCache(urlId))
  .catch(() => {
    // Handle the error and do nothing
    return null
  })
}

const filterDomain = (domain) => {
  return callExtension(ext => ext.filterDomain(domain))
  .catch(() => {
    // Handle the error and do nothing
    return null
  })
}

const showUrl = (url, recState) => {
  return callExtension((ext => ext.showUrl(url, { recState })), 500)
}

module.exports = {
  exists,
  ping,
  clearUserCache,
  clearUrlCache,
  clearUrlStateCache,
  filterDomain,
  showUrl
}
